import { Box, Flex, Text } from '@chakra-ui/layout';
import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Grid, Heading, Spinner } from "@chakra-ui/react";
import Lesson from "../../layout/Lesson";
import Objectives from "../../layout/Objectives";
import { useSelector } from 'react-redux';
import { useStudentAuthDispatch, StateType } from '../../../store/store';
import { getStudentAssignments, getStudentLessons, getStudentNotes, getStudentRegisteredCourses } from '../../../action/studentAction';

export default function StudentHome() {
  const dispatch = useStudentAuthDispatch();
  const { data: { token }, registeredCourses: { registered_courses }, lessons: { lessons }, assignments: { assignments }, notes: { notes } } = useSelector((state: StateType) => state.rootReducer.studentReducer);
  const studentToken = token.includes("Bearer") ? token.slice(17, (token.length - 2)) : token.slice(10, (token.length - 2));

  let { path, url, params } = useRouteMatch();
  console.log({ params });

  useEffect(() => {
    if (token !== "") {
      dispatch(getStudentLessons(studentToken));
      dispatch(getStudentNotes(studentToken));
      dispatch(getStudentAssignments(studentToken));
      dispatch(getStudentRegisteredCourses(studentToken));
    }
  }, [studentToken]);

  if (token === "") {
    return <Flex justifyContent="center" alignItems="center" height="100%" width="100%">
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
      />
    </Flex>
  }

  return (
    <Flex p={5} flexDirection={{ base: "column", lg: "row" }}>
      <Flex flexDirection={"column"} w={{ lg: "52%" }} bgColor={"white"} borderRadius={"30px"} p={"30px"}
        marginRight={{ base: "0", lg: "10px" }}
        marginBottom={{ base: "15px", lg: "0px" }}>
        <Text fontSize={"1.5rem"} fontStyle={"normal"} fontWeight={"700"} textTransform={"capitalize"}
          mb={3.5}>lessons</Text>
        {lessons.length < 1 ? (
          <Text>No Lessons</Text>
        ) : lessons.map((lesson, index) => (
          <Lesson key={index}
            poster={"https://upload.wikimedia.org/wikipedia/commons/e/e8/Elephants_Dream_s5_both.jpg"}
            src={lesson.video_link}
            course={lesson.course_name} session={1} topic={4} description={lesson.course_description} teacher={lesson.teacher_username} />
        ))}
      </Flex>
      <Flex h={"100%"} flexDirection="column" w={{ lg: "48%" }} bgColor={"white"} borderRadius={"30px"} p={"30px"}
        marginLeft={{ base: "0", lg: "10px" }}
        marginTop={{ base: "15px", lg: "0px" }}>
        <Text fontSize={"1.5rem"} fontStyle={"normal"} fontWeight={"bold"} textTransform={"capitalize"}
          textAlign={{ base: "center", lg: "left" }} mb={"14px"}>objectives</Text>
        <Grid templateColumns={{ lg: "repeat(auto-fit, minmax(150px, 1fr))" }}
          flexDirection={{ base: "column", lg: "row" }}>
          <Objectives number={assignments.length} type={"Assignment(s)"} />
          <Objectives number={registered_courses.length} type={"Course(s)"} />
          <Objectives number={notes.length} type={"Note(s)"} />
        </Grid>
      </Flex>
    </Flex>
  )
}
